import "./instrument";
import "./polyfills";
import * as React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import * as Scrivito from "scrivito";
import "./objs";
import "./widgets";
import { configure } from "config";
import "assets/stylesheets/index.scss";
import App from "./App";

// Suppress reactstrap bug: https://github.com/reactstrap/reactstrap/issues/2819
const originalError = console.error;
console.error = (...args) => {
  const message = args.join(" ");
  if (
    message.includes("transition.timeout") ||
    message.includes("prop `timeout` is marked as required in `Fade`")
  ) {
    return;
  }
  originalError(...args);
};

configure();

if (window.preloadDump) {
  Scrivito.preload(window.preloadDump).then(({ dumpLoaded }) => {
    delete window.preloadDump;
    dumpLoaded ? hydrateApp() : renderApp();
  });
} else {
  window.prerenderReady = false;
  renderApp(() =>
    Scrivito.finishLoading().then(() => {
      window.prerenderReady = true;
    }),
  );
}

function renderApp(renderCallback) {
  const container = document.getElementById("application");
  const root = createRoot(container);
  root.render(<App callback={renderCallback} />);
}

function hydrateApp() {
  const container = document.getElementById("application");
  hydrateRoot(container, <App callback={() => Scrivito.updateContent()} />);
}
